import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Password from "../Login/Password";

const NAV_SECTIONS = [
  {
    section: "Operaciones",
    items: [
      { label: "Modelos",      icon: "fas fa-tshirt",            href: "/MenuArticulos",   perm: "menu_articulos" },
      { label: "Compras",      icon: "fas fa-shopping-cart",     href: "/MenuCompras",     perm: "menu_compras"   },
      { label: "Ventas",       icon: "fas fa-cash-register",     href: "/MenuVentas",      perm: "menu_ventas"    },
      // { label: "Tiendas",      icon: "fas fa-store",             href: "/MenuTiendas",     perm: "menuTiendas"    },
    ],
  },
  {
    section: "Inventarios",
    items: [
      { label: "Inventarios",  icon: "fas fa-boxes",             href: "/MenuInventarios", perm: "menu_inventarios" },
    ],
  },
  {
    section: "Finanzas",
    items: [
      { label: "Admin",        icon: "fas fa-hand-holding-usd",  href: "/MenuAdmin",       perm: "configAdmin"      },
      { label: "CXP",          icon: "fas fa-file-invoice",      href: "/MenuCXP",         perm: "pagoProveedores"  },
      { label: "Gastos",       icon: "fas fa-wallet",            href: "/MenuGastos",      perm: "menu_admin"       },
    ],
  },
  {
    section: "Recursos",
    items: [
      { label: "Empleados",    icon: "fas fa-users",             href: "/MenuNominas",     perm: "menu_empleados"   },
    ],
  },
  {
    section: "Análisis",
    items: [
      { label: "Reportes",     icon: "fas fa-chart-bar",         href: "/MenuReportes",    perm: "menu_reportes"    },
    ],
  },
  {
    section: "Admin",
    items: [
      { label: "Usuarios",     icon: "fas fa-user-cog",          href: "/MenuUsuarios",    perm: "menu_usuarios"    },
      { label: "Logs",         icon: "fas fa-clipboard-list",    href: "/MenuLogs",        perm: "menu_logs"        },
    ],
  },
];

const MELI_ONLY_SECTIONS = [
  {
    section: "Operaciones",
    items: [
      { label: "Tiendas", icon: "fas fa-store", href: "/MenuTiendas", perm: "menuTiendas" },
    ],
  },
];

const Header = () => {
  const { isAuth, user } = useContext(AuthContext);

  const AREAS_MELI      = process.env.REACT_APP_AREAS_MELI_1_FULL;
  const AREAS_MELI_NOVA = process.env.REACT_APP_AREAS_MELI_2_FULL;
  const AREAS_AMAZON    = process.env.REACT_APP_AREAS_AMAZON_1_FBA;
  const AREAS_AMAZON_YOU = process.env.REACT_APP_AREAS_AMAZON_2_FBA;

  const [sidebarOpen,   setSidebarOpen]   = useState(false);
  const [modalPassword, setModalPassword] = useState(false);
  const [userMenuOpen,  setUserMenuOpen]  = useState(false);
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebar-collapsed") === "true"
  );

  const currentPath = window.location.pathname;

  const isMeliAmazonUser =
    user &&
    (user.areas === AREAS_MELI ||
      user.areas === AREAS_MELI_NOVA ||
      user.areas === AREAS_AMAZON ||
      user.areas === AREAS_AMAZON_YOU);

  const sections = isMeliAmazonUser ? MELI_ONLY_SECTIONS : NAV_SECTIONS;

  useEffect(() => {
    if (!isAuth) return;
    document.body.classList.add("has-sidebar");
    if (collapsed) document.body.classList.add("sidebar-collapsed");
    return () => {
      document.body.classList.remove("has-sidebar");
      document.body.classList.remove("sidebar-collapsed");
    };
  }, [isAuth]); // eslint-disable-line

  if (!isAuth) return null;

  const hasPerm = (perm) => {
    if (!user) return false;
    return !!user[perm];
  };

  const toggleCollapse = () => {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem("sidebar-collapsed", next);
    if (next) {
      document.body.classList.add("sidebar-collapsed");
      setUserMenuOpen(false);
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  };

  return (
    <>
      {/* Mobile top bar */}
      <div className="sidebar-topbar d-lg-none">
        <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
          <i className="fas fa-bars" />
        </button>
        <a href="/Inicio">
          <img src={process.env.PUBLIC_URL + "/LogoInstitucion.png"} height="34" alt="logo" />
        </a>
      </div>

      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <aside
        className={[
          "app-sidebar",
          sidebarOpen ? "open"      : "",
          collapsed   ? "collapsed" : "",
        ].filter(Boolean).join(" ")}
      >
        {/* Brand */}
        <div className="sidebar-brand">
          <a href="/Inicio" className="sidebar-logo-link">
            <img
              src={process.env.PUBLIC_URL + "/LogoInstitucion.png"}
              alt="logo"
              style={{ maxHeight: 44, width: "auto" }}
            />
          </a>
          <button
            className="sidebar-collapse-btn"
            onClick={toggleCollapse}
            title={collapsed ? "Expandir" : "Comprimir"}
          >
            <i className={`fas fa-chevron-${collapsed ? "right" : "left"}`} />
          </button>
        </div>

        {/* Nav */}
        <nav className="sidebar-nav">
          {sections.map((sec) => {
            const visibleItems = sec.items.filter((i) => hasPerm(i.perm));
            if (visibleItems.length === 0) return null;

            return (
              <div key={sec.section} className="sidebar-section-group">
                <div className="sidebar-section">{sec.section}</div>

                {visibleItems.map((item) => {
                  const isActive = currentPath === item.href;
                  return (
                    <a
                      key={item.href}
                      href={item.href}
                      className={`sidebar-item${isActive ? " active" : ""}`}
                      title={collapsed ? item.label : ""}
                    >
                      <i className={item.icon} />
                      <span className="sidebar-label">{item.label}</span>
                    </a>
                  );
                })}
              </div>
            );
          })}
        </nav>

        {/* User footer */}
        <div className="sidebar-footer">
          <div
            className="sidebar-item"
            onClick={() => !collapsed && setUserMenuOpen(!userMenuOpen)}
            title={collapsed ? (user.nombre || user.email || "Usuario") : ""}
            style={{ justifyContent: collapsed ? "center" : "space-between" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
              <i className="fas fa-user-circle" />
              <span className="sidebar-label" style={{ fontSize: "0.78rem" }}>
                {user.nombre || user.email || "Usuario"}
              </span>
            </div>
            {!collapsed && (
              <i className={`fas fa-chevron-${userMenuOpen ? "down" : "up"} fa-xs`} style={{ opacity: 0.5 }} />
            )}
          </div>

          {userMenuOpen && !collapsed && (
            <div className="sidebar-submenu">
              <div
                className="sidebar-item sidebar-item-sm"
                onClick={() => { setModalPassword(true); setUserMenuOpen(false); }}
              >
                <i className="fas fa-lock" />
                <span>Cambiar contraseña</span>
              </div>
              <a href="/Logout" className="sidebar-item sidebar-item-sm" style={{ color: "#f87171" }}>
                <i className="fas fa-sign-out-alt" />
                <span>Cerrar sesión</span>
              </a>
            </div>
          )}
        </div>
      </aside>

      <Modal size="sm" isOpen={modalPassword} toggle={() => setModalPassword(false)}>
        <ModalHeader toggle={() => setModalPassword(false)}>
          Cambio de contraseña
        </ModalHeader>
        <ModalBody>
          <Password />
        </ModalBody>
      </Modal>
    </>
  );
};

export default Header;
